// extracted by mini-css-extract-plugin
export var actions = "_ri-5";
export var assistantBubble = "_ri-3";
export var assistantRow = "_ri-6";
export var bubble = "_ri-0";
export var humanAvatar = "_ri-4";
export var inlineToolCard = "_ri-1";
export var userBubble = "_ri-2";